<template>
	<header id="masthead" class="site-header-admin" :class="scrollTop > 200 ? classSticky : ''" ref="admin-header">
		<div class="container-fluid">
			<div class="site-header-admin__container">
				<div class="site-header-admin__branding">
					<router-link class="site-header-admin__logo" :to="{ name: whereToGo() }">
						<img class="site-header-admin__logo-img" src="@/assets/images/logo.png" alt="Logo" title="">
					</router-link>
				</div>
				<div class="site-header-admin__nav-outer">
					<div class="site-header-admin__nav-inner">
						<MainAdminNavigation/>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import MainAdminNavigation from '@/components/main/MainNavigation/MainAdminNavigation';
import { check } from '@/services/RouteGuards/Admin';
import * as checkSuper from '@/services/RouteGuards/SuperAdmin';

export default {
	components: {
		MainAdminNavigation
	},

	data () {
		return {
			innerWidth: 0,
			scrollTop: 0,
			classSticky: 'is-sticky',
			classScroll: 'prevent-scroll'
		};
	},

	computed: {
		menuItems () {
			return this.$store.getters['menus/getMenuItems'];
		}
	},
	methods: {
		whereToGo() {
			if (this.checkPermissionsAdmin()) {
				return 'Properties';
			} else if (this.checkPermissionsSuper()) {
				return 'CustomersAgent';
			} else {
				return 'LandingPage';
			}
		},
		checkPermissionsAdmin() {
			return check();
		},
		checkPermissionsSuper() {
			return checkSuper.check();
		},
		handleResize () {
			this.innerWidth = window.innerWidth;
		},
		setScrollTop () {
			this.scrollTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
		}
	},

	watch: {
		innerWidth (newWidth) {
			this.showHamburger = newWidth < 1200;
		}
	},
	beforeMount () {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('scroll', this.setScrollTop);

		this.handleResize();
		this.setScrollTop();
	},

	destroyed () {
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('scroll', this.setScrollTop);
	}
};
</script>

<style lang="scss" scoped>
.site-header-admin {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 15px;
	background-color: $athens-gray;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 84px;
	z-index: 9999999999;
	transition: $dur / 2 $ease;
	will-change: transform;

	.container {
		@include mq($xl) {
			margin: 0;
		}
	}

	div {
		height: 100%;

		@include mq($xl) {
			height: auto;
		}
	}

	@include mq($xl) {
		height: 60px;
	}

	.container-fluid {
		@include mq($xl) {
			padding: 0;
		}
	}
}

.site-header-admin__container {
	display: flex;
	align-items: center;
    width: 100%;

	@include mq($xl) {
		padding-left: 50px;
	}
}

.site-header-admin__branding {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: $dur $ease;

	@include mq($xl) {
		margin-left: 0;
	}
}

.site-header-admin__logo {
	color: $white;
	display: block;
	width: 117px;

	@include mq($xl) {
		width: 95px;
	}

	@include mq($md) {
		width: 70px;
	}
}

.site-header-admin__logo-img {
	display: block;
	width: 100%;
}

.site-header-admin__nav-outer {
	width: 100%;
	display: flex;
	justify-content: flex-end;
}

</style>
